exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.centered[data-v-545cab8a] {\n\ttext-align: center;\n}\n", ""]);

// exports
